<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" @change="getSpecialtyList" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.specialtyId" placeholder="所属专业" @change="getLevel" filterable clearable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in specialtyList" :key="index" :label="item.specialtyName" :value="item.specialtyId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.gradeId" placeholder="级别" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.gradeName" :value="item.gradeId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.agentId" placeholder="考级点" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;"
                   v-if="!$store.state.specialRole">
          <el-option v-for="(item,index) in agentList" :key="index" :label="item.agentName" :value="item.agentId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.evaluateStatus" placeholder="评审状态" filterable style="width: 200px;margin-right:10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.evaluateStatus2)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeName" clearable placeholder="考生姓名"></el-input>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeIdNo" clearable placeholder="证件号"></el-input>
        <el-select v-model="queryParam.teacherId" placeholder="评委老师" @change="getPage({pageNum: 1})" filterable style="width: 200px;margin-right:10px;">
          <el-option v-for="item in teacherList" :key="item.userId" :label="item.username" :value="item.userId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-date-picker v-model="publishTime" type="daterange" range-separator="至" start-placeholder="发布开始日期" end-placeholder="发布结束日期"
                        value-format="yyyy-MM-ddTHH:mm:ss" :default-time="['00:00:00','23:59:59']" style="width:410px;margin-right:10px;margin-bottom: 10px;"></el-date-picker>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="reset" type="default">重置</el-button>
        <el-button @click="exam()" type="primary" v-if="!$store.state.specialRole">导入名单</el-button>
        <!--        <el-button @click="exportExcel()" type="primary" v-if="!$store.state.specialRole">导出成绩单</el-button>-->
        <!--        <el-button @click="exportResultExcel()" type="primary" v-if="!$store.state.specialRole">导出成绩表格</el-button>-->
        <KtButton @click="exportExcel()" label='导出成绩单' perms='evaluation-performance-export' type="primary"/>
        <KtButton @click="exportResultExcel()" label='导出成绩表格' perms='evaluation-excel-export' type="primary"/>
        <el-button @click="downloadTemp()" type="text" style="margin-right: 10px;" v-if="!$store.state.specialRole">线下成绩模板</el-button>
      </div>
      <div class="text-right" style="margin-top: 10px;">
        <el-button @click="publishAllResult()" type="primary" style="margin-right: 10px;">一键发布成绩</el-button>
        <el-button @click="publish()" type="primary" style="margin-right: 0px;">
          发布
        </el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium" @selection-change="multipleSelection=$event">
        <el-table-column type="selection" width="55" :selectable="row=>row.evaluateStatus>=2"></el-table-column>
        <el-table-column prop="examineeName" label="姓名">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye2">
              <span class="text-click pointer"
                    @click="$router.push({path:'./performance-edit',query:{batchId:scope.row.batchId,specialtyId:scope.row.specialtyId,examId:scope.row.examId}})">
                    {{scope.row.examineeName}}
              </span>
              <i v-if="scope.row.examineeName" style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye2">
              <span class="text-click pointer"
                    @click="$router.push({path:'./performance-edit',query:{batchId:scope.row.batchId,specialtyId:scope.row.specialtyId,examId:scope.row.examId}})">
                    {{scope.row.examineeName2}}
              </span>
              <i v-if="scope.row.examineeName2" style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="agentName" label="考级点" v-if="!$store.state.specialRole"></el-table-column>
        <el-table-column prop="categoryName" label="所属分类" v-if="!$store.state.specialRole"></el-table-column>
        <el-table-column prop="specialtyName" label="所属专业">
          <template slot-scope="scope">
            {{scope.row.specialtyName}}-{{scope.row.gradeName}}
          </template>
        </el-table-column>
        <el-table-column prop="examineeIdNo" label="证件号">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye">
              <span>{{scope.row.examineeIdNo}}</span>
              <i v-if="scope.row.examineeIdNo" style="margin-left: 5px;" class="el-icon-view" @click="reloadIdNo(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye">
              <span>{{scope.row.examineeIdNo2}}</span>
              <i v-if="scope.row.examineeIdNo2" style="margin-left: 5px;" class="el-icon-view" @click="reloadIdNo(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="mainTeacherNames" label="评委老师">
          <template slot-scope="scope">
            {{scope.row.mainTeacherNames}}<span v-if="scope.row.teacherNames">,{{scope.row.teacherNames}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="evaluateSpend" label="评分用时/s">
          <template slot-scope="scope">
            <span v-if="!scope.row.teacherIds">{{scope.row.evaluateSpend}}</span>
            <span v-else>{{scope.row.mainTeacherEvaluateSpend}},{{scope.row.teacherEvaluateSpend}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="publishTime" label="成绩发布时间"></el-table-column>
        <el-table-column prop="evaluateResult" label="综合成绩"></el-table-column>
        <el-table-column prop="evaluateStatus" label="评审状态">
          <template slot-scope="scope">
            {{$enums.evaluateStatus2[scope.row.evaluateStatus]}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.evaluateStatus == 2 || scope.row.evaluateStatus == 3" size="mini" type="text" @click="editUser(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog title="导入考生数据" v-if="examForm.show" :visible.sync="examForm.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Exam :row="examForm.row" @close="onClose"></Exam>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <p>当前进度</p>
      <div style="text-align: center">
        <el-progress type="circle" :percentage="percent"></el-progress>
      </div>
      <div v-if="currentNum && totalNum" style="width: 100%;text-align: center;margin-top: 10px;">
        当前数据进度：
        <span>{{currentNum}}</span>/<span>{{totalNum}}</span>
      </div>
    </el-dialog>
    <el-dialog title="编辑考生数据" v-if="editUserForm.show" :visible.sync="editUserForm.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <editUser :row="editUserForm.row" @close="onCloseDialog"></editUser>
    </el-dialog>
  </div>
</template>
<script>
import Exam from './certificate-edit'
import editUser from './performance-editUser'
import KtButton from '../../components/ktButton'

export default {
  name: 'list',
  components: { Exam, editUser, KtButton },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      multipleSelection: [],
      editForm: { show: false, row: null },
      batchList: [],
      specialtyList: [],
      agentList: [],
      evaluateStatus: [],
      examForm: { show: false, row: null },
      editUserForm: { show: false, row: null },
      dialogVisible: false,
      percent: null,
      publishTime: [],
      teacherList: [],
      gradeList: [],
      totalNum: '',
      currentNum: ''
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('没有考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    await this.getSpecialtyList()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
    this.teacherList = await this.$HTTP.GradeUser.getList({ batchId: this.row, roomId: this.room })
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
    clearInterval(this.taskInterval)
  },
  computed: {},
  watch: {},
  methods: {
    async reset () {
      this.$router.replace({ query: null })
      window.location.reload()
      // this.queryParam = JSON.parse(JSON.stringify(this.oldQueryParam))
      // this.getPage({ pageNum: 1 })
      // this.getSpecialtyList()
      // this.gradeList = []
    },
    async getSpecialtyList (event) {
      this.specialtyList = await this.$HTTP.ApiSpecialty.getList({ batchId: this.queryParam.batchId })
      this.agentList = await this.$HTTP.ApiBatch.getAgentList(this.queryParam.batchId)
      if (event) {
        this.queryParam.specialtyId = ''
        this.queryParam.agentId = ''
        this.queryParam.gradeId = ''
        this.gradeList = []
      }
      await this.getPage()
    },
    async getLevel (event) {
      if (event) {
        this.queryParam.gradeId = ''
      }
      this.gradeList = await this.$HTTP.ApiGrade.getList({ specialtyId: this.queryParam.specialtyId, status: 2 })
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        this.queryParam.publishStartTime = ''
        this.queryParam.publishEndTime = ''
        this.editForm.show = false
        this.editForm.row = null
        if (this.publishTime) {
          this.$set(this.queryParam, 'publishStartTime', this.publishTime[0])
          this.$set(this.queryParam, 'publishEndTime', this.publishTime[1])
        }
        let newQueryParam = JSON.parse(JSON.stringify(this.queryParam))
        if (newQueryParam.evaluateStatus || newQueryParam.evaluateStatus == 0) {
          newQueryParam.evaluateStatus = [newQueryParam.evaluateStatus]
        }
        // if (queryParam && !queryParam.pageSize) {
        //   this.$set(queryParam, 'pageSize', this.page.pageSize)
        // }
        newQueryParam = Object.assign({}, newQueryParam, queryParam)
        let page = await this.$HTTP.GradeExam.getEvaluateExamPage(newQueryParam)
        if (page.list) {
          page.list.map(el => {
            this.$set(el, 'examineeIdNo2', el.examineeIdNo)
            this.$set(el, 'examineeName2', el.examineeName)
            this.$set(el, 'trueEye2', true)
            this.$set(el, 'trueEye', true)
            // el.examineeIdNo2 = el.examineeIdNo.replace(/^(.{6})(?:\w+)/, "\$1********")
            // el.examineeName2 = el.examineeName.replace(/(?<=.)./g, '*')
            if (el.examineeIdNo) {
              el.examineeIdNo2 = el.examineeIdNo.replace(/^(.{6})(?:\w+)/, "\$1********")
            }
            if (el.examineeName) {
              el.examineeName2 = el.examineeName.replace(/(?<=.)./g, '*')
            }
          })
        }
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async reloadIdNo (index, row) {
      if (row.trueEye == true) {
        this.$set(row, 'trueEye', false)
      } else {
        this.$set(row, 'trueEye', true)
      }
    },
    async reloadName (index, row) {
      if (row.trueEye2 == true) {
        this.$set(row, 'trueEye2', false)
      } else {
        this.$set(row, 'trueEye2', true)
      }
    },
    async edit (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.row = row
      } else {
        this.editForm.row = null
      }
    },
    async editUser (row) {
      this.editUserForm.show = true
      if (row) {
        this.editUserForm.row = row
      } else {
        this.editUserForm.row = null
      }
    },
    async publish () {
      if (!this.multipleSelection.length) {
        throw new Error('请选择要操作的记录')
      }
      let confirm = await this.$confirm('确定要发布该记录吗？', '提示', { type: 'warning' })
      if (confirm === 'confirm') {
        await this.$HTTP.GradeExam.publish({
          evaluateExamIds: this.Tool.joinList(this.multipleSelection, 'evaluateExamId')
        })
        this.$message({ type: 'success', message: '发布成功' })
        await this.getPage()
      }
    },
    async onClose (event) {
      try {
        // await this.$HTTP.GradeExam.getImportExamResult(this.queryParam)
        this.getTaskInfo('import_exam_result')
        this.examForm.show = false
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async onCloseDialog (event) {
      try {
        this.editUserForm.show = false
        await this.getPage()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async exportExcel (queryParam) {
      try {
        this.queryParam.publishStartTime = ''
        this.queryParam.publishEndTime = ''
        if (this.publishTime) {
          this.$set(this.queryParam, 'publishStartTime', this.publishTime[0])
          this.$set(this.queryParam, 'publishEndTime', this.publishTime[1])
        }
        let newQueryParam = JSON.parse(JSON.stringify(this.queryParam))
        if (newQueryParam.evaluateStatus || newQueryParam.evaluateStatus == 0) {
          newQueryParam.evaluateStatus = [newQueryParam.evaluateStatus]
        }
        newQueryParam = Object.assign({}, newQueryParam, queryParam)
        await this.$HTTP.GradeExam.getexportExamResult(newQueryParam)
        this.getTaskInfo('export_exam_result')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async exportResultExcel (queryParam) {
      try {
        this.queryParam.publishStartTime = ''
        this.queryParam.publishEndTime = ''
        if (this.publishTime) {
          this.$set(this.queryParam, 'publishStartTime', this.publishTime[0])
          this.$set(this.queryParam, 'publishEndTime', this.publishTime[1])
        }
        let newQueryParam = JSON.parse(JSON.stringify(this.queryParam))
        if (newQueryParam.evaluateStatus || newQueryParam.evaluateStatus == 0) {
          newQueryParam.evaluateStatus = [newQueryParam.evaluateStatus]
        }
        newQueryParam = Object.assign({}, newQueryParam, queryParam)
        await this.$HTTP.GradeExam.getexportEvaluateExamResult(newQueryParam)
        this.getTaskInfo('export_evaluate_exam_result')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async publishAllResult (queryParam) {
      try {
        let confirm = await this.$confirm('确定一键发布“全部已评分考生”成绩吗？发布后不可撤销', '提示', { type: 'warning'})
        if (confirm === 'confirm') {
          let newQueryParam = JSON.parse(JSON.stringify(this.queryParam))
          if (newQueryParam.evaluateStatus || newQueryParam.evaluateStatus == 0) {
            newQueryParam.evaluateStatus = [newQueryParam.evaluateStatus]
          }
          newQueryParam = Object.assign({}, newQueryParam, queryParam)
          await this.$HTTP.GradeExam.publishEvaluate(newQueryParam)
          this.getTaskInfo('batch_publish_evaluate')
        }
      }catch (e) {
        this.Tool.doError(e)
      }
    },
    getTaskInfo (taskName) {
      this.taskInterval = setInterval(async () => {
        try {
          let taskInfo = await this.$HTTP.ApiExamResult.getTaskInfo(taskName)
          this.percent = taskInfo.percent
          this.totalNum = taskInfo.totalNum
          this.currentNum = taskInfo.currentNum
          if (taskInfo) {
            if (taskInfo.status == 0 && taskInfo.status != 2) {
              this.dialogVisible = true
            }
            if (taskInfo.errorExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.errorExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.successExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.successExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.percent >= 100) {
              clearInterval(this.taskInterval)
              this.$message({ type: 'success', message: '操作成功' })
              await this.getPage()
            } else if (taskInfo.status >= 2) {
              clearInterval(this.taskInterval)
              this.dialogVisible = false
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              }
              await this.getPage()
            }
          } else {
            clearInterval(this.taskInterval)
            this.$message({ type: 'error', message: taskInfo.errMsg })
          }
          if (taskInfo.percent >= 100) {
            this.dialogVisible = false
          }
        } catch (e) {
          clearInterval(this.taskInterval)
        }
      }, 2000)
    },
    async exam (row) {
      this.examForm.show = true
      if (row) {
        this.examForm.row = row
      } else {
        this.examForm.row = null
      }
    },
    async downloadTemp () {
      let url = 'http://zego-davinci-public.oss-cn-shanghai.aliyuncs.com/dev/hbyx/import_model/import_result.xlsx'
      let fileUrl = await this.$HTTP.ApiOss.signatureUrl(url, 'public-read')
      this.Tool.downloadFile(fileUrl)
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms)
    },
    getPermission () { // 模拟接口 获取 权限数据集合
      let perms = this.$store.state.buttonList
      // this.$store.dispatch("SET_PERMISSION", perms)
    }
  }
}
</script>
